import React from 'react';
import { Card } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import { shape } from 'prop-types';
import urlEncode from '../urlEncode';

const GenreItem = ({ genre }) => {
  const { name, image } = genre;
  return (
    <Card
      header={name}
      image={`https://www.twr360.org/images/sized/${image}/c290x220/thumb.jpg?p=files/library`}
      as={Link}
      to={`/stations/${urlEncode(name)}`}
    />
  );
};

GenreItem.propTypes = {
  genre: shape().isRequired
  // selectGenre: func.isRequired,
};

export default GenreItem;
